import { render, staticRenderFns } from "./MainInputRadioGroup.vue?vue&type=template&id=4ede243c&scoped=true"
import script from "./MainInputRadioGroup.vue?vue&type=script&lang=js"
export * from "./MainInputRadioGroup.vue?vue&type=script&lang=js"
import style0 from "./MainInputRadioGroup.vue?vue&type=style&index=0&id=4ede243c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ede243c",
  null
  
)

export default component.exports